import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Users } from 'lucide-react';

const ServicesCTA = () => {
  const navigate = useNavigate();

  const handleAboutClick = () => {
    navigate('/about');
    window.scrollTo(0, 0);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="contact-cta" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8">
          {/* About CTA */}
          <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6 hover:shadow-2xl transition-shadow duration-300">
            <div className="inline-block p-3 bg-blue-50 rounded-lg">
              <Users className="w-8 h-8 text-blue-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900">
              Meet Our Team
            </h3>
            <p className="text-gray-600">
              Curious about the people behind our dynamic strategies? Learn more about our expert team driving success stories. Explore our journey here.
            </p>
            <Button
              onClick={handleAboutClick}
              className="bg-blue-600 hover:bg-blue-700 text-white group w-full sm:w-auto"
            >
              Explore our Story
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>

          {/* Contact CTA */}
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl shadow-xl p-8 space-y-6 hover:shadow-2xl transition-shadow duration-300 text-white">
            <div className="inline-block p-3 bg-white/20 rounded-lg">
              <ArrowRight className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold">
              Ready to Grow?
            </h3>
            <p>
              Supercharge your business with our performance and growth marketing solutions. Ready to take the leap? Let's discuss your growth strategy.
            </p>
            <Button
              onClick={scrollToTop}
              className="bg-white text-blue-600 hover:bg-gray-100 group w-full sm:w-auto"
            >
              Contact us Now
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesCTA;